
import { ref } from 'vue';

export default {
  name: 'LayoutDefault',

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  setup() {
    return {
      leftDrawerOpen: ref(false),
    };
  },
};
